import PropTypes from 'prop-types';
import React from 'react';

import BrButton from '@components/BrButton';

export default function ButtonColumn({ row, col, cell }) {
  return (
    <div>
      <BrButton
        title={cell.value || col.columnConfig.title}
        isLoading={cell.isLoading}
        isDisabled={cell.isDisabled}
        colorStyle={col.columnConfig.colorStyle}
        icon={col.columnConfig.icon}
        onClick={() => col.columnConfig.onClick(row)}
      />
    </div>
  );
}

ButtonColumn.propTypes = {
  row: PropTypes.object.isRequired, // row data
  col: PropTypes.shape({
    // column config
    columnConfig: PropTypes.shape({
      title: PropTypes.string,
      colorStyle: PropTypes.string,
      icon: PropTypes.element,
      onClick: PropTypes.func.isRequired, // (row: obj) :=> {}
    }).isRequired,
  }).isRequired,
  cell: PropTypes.shape({
    value: PropTypes.string, // if specified, this will replace the col.value
    isLoading: PropTypes.bool,
    isDisabled: PropTypes.bool,
  }).isRequired,
};
